<span *ngIf="!isEmailValid">{{email}}</span>
<a *ngIf="isEmailValid"
   [href]="'mailto:' + email">{{email}}</a>
